import { pharmacies, withSession } from '@zipdrug/react-api-sdk';
import { get } from 'lodash';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import fetchOnceOptions from './utils/fetchOnceOptions';
import withPharmacyId from './withPharmacyId';

const withCurrentPharmacy = ComponentToWrap =>
  graphql(pharmacies.queryPharmacies, {
    skip: ({ userId, pharmacy_id }) => {
      return !userId || !pharmacy_id;
    },
    options: ({ pharmacy_id }) =>
      fetchOnceOptions('currentPharmacy', {
        variables: {
          query: { id: pharmacy_id },
        },
      }),
    props: ({ 
      data: { pharmacies: result }, 
      ownProps: { pharmacy_id } 
    }) => ({
      currentPharmacy: get(result, 'data', []).find(pharmacy => pharmacy.id === pharmacy_id)
      || get(result, 'data[0]'), // Fallback to the first item if find method returns undefined
    }),
  })(ComponentToWrap);

export default Component => compose(withSession, withPharmacyId, withCurrentPharmacy)(Component);
